import React from "react";

import LogoPath from "@images/logo_full.svg";
import LogoPathGrey from "@images/logo_grey.svg";
import { useLocation } from "@reach/router";
import { Link } from "gatsby";

import Image from "@/components/common/image";
import { reviewPagePath } from "@/components/constants";

import { LogoProps } from "./types";

const Logo = ({ className, isFooter = false }: LogoProps) => {
  const location = useLocation();
  const redirectFromReviewPage = location.pathname === reviewPagePath;

  return (
    <Link to="/" className={className} state={{ showBannerFromFlocktory: !!redirectFromReviewPage }}>
      {/* пропорция файлов logo_full и logo_grey (3891×1234): место под логотип занято до загрузки */}
      {process.env.GATSBY_LOCALIZATION !== "mirror" && <Image src={isFooter ? LogoPathGrey : LogoPath} alt="Lunaro" width="151" height="48" priority={!isFooter} />}
      {process.env.GATSBY_LOCALIZATION === "mirror" && <p>Lunaro.guru</p>}
    </Link>
  );
};

export default Logo;
